module.exports = __webpack_public_path__ + "static/cs_contact_bg-74aa13187d8a4563f00d795340b3443a.png";